import { jwtDecode, JwtPayload } from "jwt-decode";

interface CPF extends JwtPayload {
  doc_number: string;
}

const getByToken = (): string => {
  const tokenOidc =
    localStorage.getItem("globoid-tokens-alf@apps.globoid") || "";

  if (!tokenOidc || tokenOidc === "") {
    return "";
  }
  const token = JSON.parse(tokenOidc).id_token;

  const decodedToken = jwtDecode<CPF>(token);
  const { doc_number } = decodedToken;
  return doc_number;
};

/**
 * Formats a cpf string as "000.000.000-00".
 */
function formatCPF(cpf: string): string {
  return cpf
    .replace(/\D/g, "")
    .replace(/(\d{3})(\d)/, "$1.$2")
    .replace(/(\d{3})(\d)/, "$1.$2")
    .replace(/(\d{3})(\d{1,2})/, "$1-$2")
    .replace(/(-\d{2})\d+?$/, "$1");
}

const validateCPF = (cpf: string) => {
  let sum = 0;
  let rest;
  let i;

  const parsedCPF = cpf.replace(/\./g, "").replace("-", "");

  if (
    parsedCPF.length !== 11 ||
    parsedCPF === "00000000000" ||
    parsedCPF === "11111111111" ||
    parsedCPF === "22222222222" ||
    parsedCPF === "33333333333" ||
    parsedCPF === "44444444444" ||
    parsedCPF === "55555555555" ||
    parsedCPF === "66666666666" ||
    parsedCPF === "77777777777" ||
    parsedCPF === "88888888888" ||
    parsedCPF === "99999999999"
  ) {
    return false;
  }

  for (i = 1; i <= 9; i += 1) {
    sum += parseInt(parsedCPF.substring(i - 1, i), 10) * (11 - i);
  }
  rest = (sum * 10) % 11;
  if (rest === 10 || rest === 11) {
    rest = 0;
  }
  if (rest !== parseInt(parsedCPF.substring(9, 10), 10)) {
    return false;
  }
  sum = 0;
  for (i = 1; i <= 10; i += 1) {
    sum += parseInt(parsedCPF.substring(i - 1, i), 10) * (12 - i);
  }
  rest = (sum * 10) % 11;
  if (rest === 10 || rest === 11) {
    rest = 0;
  }
  if (rest !== parseInt(parsedCPF.substring(10, 11), 10)) {
    return false;
  }
  return true;
};

export { getByToken, formatCPF, validateCPF };
